import React from 'react';

// The preview HTML is generated by our own Phoenix editor, but strip active
// content anyway before injecting it into the admin DOM.
function sanitizeHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('script, style, iframe, object, embed, link, meta').forEach((el) => el.remove());

    doc.querySelectorAll('*').forEach((el) => {
        Array.from(el.attributes).forEach((attr) => {
            const attrName = attr.name.toLowerCase();
            const attrValue = attr.value.trim().toLowerCase();

            if (attrName.startsWith('on')
                || ((attrName === 'href' || attrName === 'src') && attrValue.startsWith('javascript:'))
            ) {
                el.removeAttribute(attr.name);
            }
        });
    });

    return doc.body.innerHTML;
}

export default class HtmlBlockPreviewTransformer {
    transform(value) {
        if (typeof value !== 'string' || value.trim() === '') {
            return null;
        }

        return (
            <div
                className="mavu-html-block-preview"
                dangerouslySetInnerHTML={{__html: sanitizeHtml(value)}}
            />
        );
    }
}
